export default class LanguagePackAddedEvent {
    constructor(id, lpAssetURL, languagePack) {
        this.id = id;
        this.languagePack = languagePack;
        this.lpAssetURL = lpAssetURL;
    }
}

LanguagePackAddedEvent.ADDED = "LanguagePackAddedEvent.ADDED";